import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {
  CreacionMantenedorComponent
} from "./aplicaciones-modulos/autoconsumo/views/creacion-mantenedor/creacion-mantenedor.component";
import {
  MantenedorSolicitudPedidoVentaComponent
} from "./aplicaciones-modulos/autoconsumo/views/mantenedor-solicitud-pedido-venta/mantenedor-solicitud-pedido-venta.component";
import {AuthGuard} from "./shared-module/seguridad/services/auth.guard";
import {HomeComponent} from "./views/home/home.component";
import {
  ConfigCierreMesModule
} from "./aplicaciones-modulos/portal-compras/pages/config-cierre-mes/config-cierre-mes.module";

const routes: Routes = [
  {
    // ! Rutas pincipales solo deben redireccionar
    path: "",
    pathMatch: "full",
    redirectTo: "home"
    // path: '',
    // component: HomeComponent,
    // canActivate: [AuthGuard]
  },
/*  {
    path: 'autogestion/mantenedor-solicitud-pedido-venta',
    component: MantenedorSolicitudPedidoVentaComponent,
  },

  {
    path: '**',
    redirectTo: 'autogestion/mantenedor-solicitud-pedido-venta'
  }*/
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'portal-compras',
    loadChildren: () => import('./aplicaciones-modulos/portal-compras/portal-compras.module').then(m => m.PortalCompraModule)
  },
  {
    path: 'config',
    loadChildren: () => import("./aplicaciones-modulos/portal-compras/pages/config/config.module").then(m => m.ConfigModule)
  },
  {
    path: 'config-cierre-mes',
    loadChildren: () => import("./aplicaciones-modulos/portal-compras/pages/config-cierre-mes/config-cierre-mes.module").then(m => m.ConfigCierreMesModule)
  },
  {
    path: 'administrator',
    loadChildren: () => import('./aplicaciones-modulos/portal-compras/pages/administrator/administrator.module').then(m => m.AdministratorModule)
  },
  {
    path: "portfolio",
    loadChildren: () => import('./aplicaciones-modulos/portfolio/portfolio.module').then(m => m.PortafolioModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'vdi',
    loadChildren: () => import('./aplicaciones-modulos/vdi/vdi.module').then((m) => m.VdiModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'ventas',
    loadChildren: () => import('./aplicaciones-modulos/ventas/ventas.module').then((m) => m.VentasModule),
    canActivate: [AuthGuard]
  },
 /* {
    path: 'cliente-ruta', 
    loadChildren: () => import('./aplicaciones-modulos/vdi/Cliente-ruta/cliente-ruta.module').then(m => m.ClienteRutaModule)
  },
  */
  {
    path: 'traslado-logist',
    loadChildren: () => import('./aplicaciones-modulos/traslado-logist/traslado-logist.module').then((m) => m.TrasladoLogistModule),
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    redirectTo: 'login'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: false})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
